import axiosInstance from "../lib/axiosInstance";

class commonModel {

    async searchPincode(pincode) {

        return (await axiosInstance.get(`/global/search_pincode/${pincode}`)).data;
    }



}

export default new commonModel();